import * as React from 'react';
import { useUpdateEffect } from 'react-use';
import { Transforms } from 'slate';
import { useSlate } from 'slate-react';

import { reSelectText } from '../../../helpers/selection';
import { insertLink } from '../transform/insertLinkAtSelection';
import { HyperLinkPopover, HyperLinkPopoverProps } from './HyperLinkPopover';

export interface HyperLinkPopoverOnExpandedProps extends HyperLinkPopoverProps {}

export const HyperLinkPopoverOnExpanded = (props: HyperLinkPopoverOnExpandedProps) => {
  const { children, onApplyLink, onPopoverClose, ...rest } = props;
  const editor = useSlate();

  const editorSelection = React.useRef(null);

  useUpdateEffect(() => {
    if (editor.selection) {
      editorSelection.current = { ...editor.selection };
    }
  }, [editor.selection]);

  const handlePopoverClose = React.useCallback(async () => {
    await reSelectText(editor, editorSelection.current);
    onPopoverClose?.();
  }, [editor, onPopoverClose]);

  const handleApplyLink = React.useCallback(
    async (url, linkSettings, linkAction) => {
      // Reselect before insertLink
      await reSelectText(editor, editorSelection.current);
      insertLink(editor, {
        url,
        linkSettings,
        linkAction,
      });

      onApplyLink?.(url, linkSettings, linkAction);
      // Deselect after insert link
      Transforms.collapse(editor, { edge: 'end' });
    },
    [editor, onApplyLink]
  );

  return (
    <HyperLinkPopover onApplyLink={handleApplyLink} onPopoverClose={handlePopoverClose} {...rest}>
      {children}
    </HyperLinkPopover>
  );
};
